__turbopack_context__.v({
  "active": "d-2gmG_active",
  "chapter": "d-2gmG_chapter",
  "chapterTimestamp": "d-2gmG_chapterTimestamp",
  "chapterTitle": "d-2gmG_chapterTitle",
  "chaptersContainer": "d-2gmG_chaptersContainer",
  "chaptersList": "d-2gmG_chaptersList",
  "panelHeader": "d-2gmG_panelHeader",
  "scrollContainer": "d-2gmG_scrollContainer",
});
